import React from 'react';

import '../css/footer.css';

export default function Home() {
	return (
        <React.Fragment>
            <footer className="flex-container center">
                <span className="copy">&copy; 2022 • Web 3 Certification</span>
            </footer>
        </React.Fragment>
    )
}